import React, { FunctionComponent, ReactNode } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import List from '@gojob/ui-bits/List';
import useTheme from '@gojob/ui-bits/styles/useTheme';

export type ListProps = {
  type?: 'bullet' | 'number';
  children: ReactNode;
};

const ListComponent: FunctionComponent<ListProps> = ({ type, ...props }) => {
  const { spacing } = useTheme();
  return (
    <Flex
      // this className is directly use below to target nested list and reset margin
      // do not use it elsewhere
      className="list-component-identifier"
      css={{
        margin: spacing(4, 0),
        '& .list-component-identifier': {
          margin: 0,
        },
      }}
    >
      <List variant={type} {...props} />
    </Flex>
  );
};

const listRenderer = (props: ListProps) => {
  return <ListComponent {...props} />;
};

export default listRenderer;
